"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FPCTPageThree;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _DisclosureModal = _interopRequireDefault(require("../Wizard/DisclosureModal"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _House = _interopRequireDefault(require("./svg/House"));
var _FPCTModals = require("./FPCTModals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* eslint-disable no-unused-vars */

function FPCTPageThree(_ref) {
  var {
    disclosureHandleClose,
    showDisclosure
  } = _ref;
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var planOnTheRightPathText = "Now that you've identified your goals and assessed your current plan, here are\n      products and services that can help strength your plan and help you reach your goals.";
  var planHasZeroSolutionsText = 'Explore these solutions with a financial professional to see how they can help strengthen your plan and reach your goals.';
  var planHasAllSolutionText = 'Reach out design to confirm the copy';
  var disclosureArray = ['This interactive calculator is a self-help tool and is not intended to provide financial advice or product recommendations. The results and explanations generated by this calculator are based upon, and will vary due to, your input and certain assumptions made by us. MassMutual will assume no liability for the use of or reliance on this calculator. For a more accurate and detailed analysis specific to your circumstances, we encourage you to contact a qualified financial professional.', 'The information provided is not written or intended as specific tax or legal advice. MassMutual, its employees and representatives are not authorized to give tax or legal advice. Individuals are encouraged to seek advice from their own tax or legal counsel.', 'Insurance products issued by Massachusetts Mutual Life Insurance Company (MassMutual) and its subsidiaries, C.M. Life Insurance Company (C. M. Life) and MML Bay State Life Insurance Company (MML Bay State), Springfield, MA 01111-0001. C.M. Life and MML Bay State are non-admitted in New York.'];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h4", null, "Analysis"), /*#__PURE__*/_react.default.createElement("div", {
    className: "pathContainer mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/_react.default.createElement(_House.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-9"
  }, planOnTheRightPathText))), /*#__PURE__*/_react.default.createElement("div", {
    className: "analysisContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    className: "no-box-shadow"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Your current plan")), /*#__PURE__*/_react.default.createElement("hr", null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: "flat"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-text-center"
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Your optimized plan"), /*#__PURE__*/_react.default.createElement("hr", null))))))), /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, {
    textArray: disclosureArray,
    handleClose: disclosureHandleClose,
    show: showDisclosure
  }));
}